/* eslint-disable import/prefer-default-export */
import {resource} from '@albert-io/json-api-framework/request/builder';
import {List} from 'immutable';

export function createManageRosterContextState(classId, boundScope) {
  const stateObject = {
    queries: {
      classroom: resource('classrooms_v1')
        .mandarkEndpoint(['classrooms_v1', classId])
        .include('school_v5.email_domains_v1,students_v2')
        .fields({student_v2: 'email'}),
      invitations: resource('classroom_invitations_v1')
        .mandarkEndpoint(['classroom_invitations_v1'])
        .filter({classroom_v1: classId})
        .filter({accepted_at: {null: true}}),
      students: resource('students_v2')
        .mandarkEndpoint(['classrooms_v1', classId, 'students_v2'])
        .withMeta('student_v2')
        .customQuery({
          meta: {
            context: {
              classroom: {id: classId}
            }
          }
        })
    },
    classroom: null,
    invitations: List(),
    isReady: false,
    modalToShow: '',
    students: List(),
    setModalToShow: (val) => boundScope.setState({modalToShow: val}),
    setClassroom: (val) => boundScope.setState({classroom: val}),
    setIsReady: (val) => boundScope.setState({isReady: val})
  };
  return stateObject;
}
